
type AnAlertTypes = number;
let AnAlertTypes: any = {};
AnAlertTypes.INFO = 0;
AnAlertTypes.WARNING = 1;
AnAlertTypes.SUCCESS = 2;
AnAlertTypes.ERROR = 3;
AnAlertTypes.BLANK = 4;
AnAlertTypes[AnAlertTypes.INFO] = "INFO";
AnAlertTypes[AnAlertTypes.WARNING] = "WARNING";
AnAlertTypes[AnAlertTypes.SUCCESS] = "SUCCESS";
AnAlertTypes[AnAlertTypes.ERROR] = "ERROR";
AnAlertTypes[AnAlertTypes.BLANK] = "BLANK";


export {AnAlertTypes};

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
